// @ts-nocheck
import {
    getSkuListByBarcodeOrModelOrSerialNumber,
    GetSkusParameter,
} from "@store/Framework/Services/PartFinderService";
import { SkuModel } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetSkusParameter & HasOnSuccess<SkuModel[]>, SkuModel[]>;

export const DispatchBeginLoadSkus: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PartFinder/BeginLoadSkus",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getSkuListByBarcodeOrModelOrSerialNumber(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const DispatchCompleteLoadSkus: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/PartFinder/CompleteLoadSkus",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginLoadSkus,
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
    DispatchCompleteLoadSkus,
];

const loadSkus = createHandlerChainRunner(chain, "LoadSkus");
export default loadSkus;
